import { SCapsule, SCapsuleHeading } from './Capsule.styled'
import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { ReactNode } from 'react'
import { Text } from 'components/Typography'

export const SCapsuleWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(${pxToRem(230)}rem, 1fr));
  grid-gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: space-between;
  @media ${BREAKPOINTS.MD.max} {
    justify-content: center;
  }
`

export function Capsule(props: { title: ReactNode; desc: string }) {
  return (
    <SCapsule>
      <SCapsuleHeading css={{ marginBottom: '0.5rem' }}>{props.title}</SCapsuleHeading>
      <Text>{props.desc}</Text>
    </SCapsule>
  )
}
